import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=14e2fded&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=ts"
export * from "./svgIcon.vue?vue&type=script&lang=ts"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=14e2fded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e2fded",
  null
  
)

export default component.exports